import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DarkModeContext } from "../../context/DarkModeContext";
import { getToken } from "../../utils/auth";

const ESTADOS = [
    { value: "nuevo",          label: "Nuevo" },
    { value: "contactado",     label: "Contactado" },
    { value: "en_seguimiento", label: "En seguimiento" },
    { value: "cerrado",        label: "Cerrado / Ganado" },
    { value: "sin_interes",    label: "Sin interés" },
];

const ESTADO_COLORS = {
    nuevo:          "#1877F2",
    contactado:     "#f0a500",
    en_seguimiento: "#17a2b8",
    cerrado:        "#28a745",
    sin_interes:    "#6c757d",
};

export default function ZTCarga() {
    const { darkMode } = useContext(DarkModeContext);
    const navegacion = useNavigate();
    const [autorizado, setAutorizado] = useState(false);
    const [cargando, setCargando] = useState(true);
    const [leads, setLeads] = useState([]);
    const [busqueda, setBusqueda] = useState("");
    const [leadSeleccionado, setLeadSeleccionado] = useState(null);
    const [form, setForm] = useState({ estado: "", observaciones: "" });
    const [guardando, setGuardando] = useState(false);
    const [mensaje, setMensaje] = useState(null);

    useEffect(() => {
        const init = async () => {
            const token = getToken();
            if (!token) { navegacion("/"); return; }
            try {
                const r = await fetch(process.env.REACT_APP_API_ZT_LEADS, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ Token: token }),
                });
                if (r.status === 401 || r.status === 403) { navegacion("/"); return; }
                if (r.ok) { setLeads(await r.json()); setAutorizado(true); }
            } catch { navegacion("/"); }
            finally { setCargando(false); }
        };
        init();
    }, [navegacion]);

    const seleccionarLead = (lead) => {
        setLeadSeleccionado(lead);
        setForm({ estado: lead.estado, observaciones: lead.observaciones || "" });
        setMensaje(null);
    };

    const guardar = async () => {
        if (!leadSeleccionado) return;
        const token = getToken();
        if (!token) return;
        setGuardando(true);
        setMensaje(null);
        try {
            const r = await fetch(
                `${process.env.REACT_APP_API_ZT_LEADS_ESTADO}/${leadSeleccionado.id}/estado`,
                {
                    method: "PUT",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        Token: token,
                        Estado: form.estado,
                        Observaciones: form.observaciones,
                    }),
                }
            );
            if (r.ok) {
                setMensaje({ tipo: "success", texto: "Lead actualizado correctamente." });
                setLeads(prev => prev.map(l =>
                    l.id === leadSeleccionado.id
                        ? { ...l, estado: form.estado, observaciones: form.observaciones }
                        : l
                ));
                setLeadSeleccionado(prev => ({ ...prev, estado: form.estado, observaciones: form.observaciones }));
            } else {
                setMensaje({ tipo: "danger", texto: "No se pudo actualizar el lead." });
            }
        } catch {
            setMensaje({ tipo: "danger", texto: "Error de conexión." });
        } finally {
            setGuardando(false);
        }
    };

    if (cargando) return (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 200 }}>
            <div className="spinner-border text-primary" />
        </div>
    );
    if (!autorizado) return null;

    const leadsFiltrados = busqueda.trim()
        ? leads.filter(l =>
            [l.nombre, l.empresa, l.telefono, l.email, l.campaignId]
                .some(v => v?.toLowerCase().includes(busqueda.toLowerCase()))
          )
        : leads;

    return (
        <div className={darkMode ? "container-dark p-3" : "p-3"}>
            <h5 className="fw-bold mb-1" style={{ color: "#1877F2" }}>Carga del closer</h5>
            <p className="text-muted mb-3" style={{ fontSize: "0.85rem" }}>
                Seleccioná un lead y actualizá su estado y observaciones
            </p>

            <div className="row g-3">
                {/* Panel izquierdo: lista de leads */}
                <div className="col-12 col-md-5 col-lg-4">
                    <div className="card border-0 shadow-sm">
                        <div className="card-body p-2">
                            <input
                                className="form-control form-control-sm mb-2"
                                placeholder="Buscar lead..."
                                value={busqueda}
                                onChange={e => setBusqueda(e.target.value)}
                            />
                            <div style={{ maxHeight: 500, overflowY: "auto" }}>
                                {leadsFiltrados.length === 0 && (
                                    <div className="text-muted text-center py-3" style={{ fontSize: "0.8rem" }}>
                                        Sin resultados
                                    </div>
                                )}
                                {leadsFiltrados.map(l => (
                                    <div
                                        key={l.id}
                                        className="p-2 rounded mb-1"
                                        style={{
                                            cursor: "pointer",
                                            backgroundColor: leadSeleccionado?.id === l.id
                                                ? "#e8f0fe"
                                                : "transparent",
                                            borderLeft: `3px solid ${ESTADO_COLORS[l.estado] || "#aaa"}`,
                                        }}
                                        onClick={() => seleccionarLead(l)}
                                    >
                                        <div className="fw-bold" style={{ fontSize: "0.82rem" }}>
                                            {l.nombre || "(sin nombre)"}
                                        </div>
                                        {l.empresa && (
                                            <div className="text-muted" style={{ fontSize: "0.73rem" }}>{l.empresa}</div>
                                        )}
                                        <div className="d-flex justify-content-between align-items-center mt-1">
                                            <span
                                                className="badge"
                                                style={{
                                                    backgroundColor: ESTADO_COLORS[l.estado] || "#aaa",
                                                    fontSize: "0.65rem",
                                                }}
                                            >
                                                {ESTADOS.find(e => e.value === l.estado)?.label || l.estado}
                                            </span>
                                            <span style={{ fontSize: "0.68rem", color: "#888" }}>
                                                {new Date(l.fechaRecibido).toLocaleDateString("es-AR")}
                                            </span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Panel derecho: formulario */}
                <div className="col-12 col-md-7 col-lg-8">
                    {!leadSeleccionado ? (
                        <div
                            className="card border-0 shadow-sm d-flex align-items-center justify-content-center"
                            style={{ minHeight: 300 }}
                        >
                            <div className="text-center text-muted">
                                <div style={{
                                    width: 56, height: 56,
                                    borderRadius: "50%",
                                    backgroundColor: "#f0f0f0",
                                    margin: "0 auto 12px auto",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}>
                                    <div style={{
                                        width: 18, height: 18,
                                        border: "2px solid #aaa",
                                        borderRadius: 3,
                                    }} />
                                </div>
                                <p style={{ fontSize: "0.85rem", marginBottom: 0 }}>Seleccioná un lead de la lista</p>
                            </div>
                        </div>
                    ) : (
                        <div className="card border-0 shadow-sm">
                            <div className="card-body">
                                {/* Datos del lead */}
                                <div className="mb-3 pb-3 border-bottom">
                                    <h6 className="fw-bold mb-2">
                                        {leadSeleccionado.nombre || "(sin nombre)"}
                                        <span
                                            className="badge ms-2"
                                            style={{
                                                backgroundColor: ESTADO_COLORS[leadSeleccionado.estado] || "#aaa",
                                                fontSize: "0.7rem",
                                            }}
                                        >
                                            {ESTADOS.find(e => e.value === leadSeleccionado.estado)?.label || leadSeleccionado.estado}
                                        </span>
                                    </h6>
                                    <div className="row g-1" style={{ fontSize: "0.82rem" }}>
                                        {leadSeleccionado.empresa   && <div className="col-12"><strong>Empresa:</strong> {leadSeleccionado.empresa}</div>}
                                        {leadSeleccionado.telefono  && <div className="col-12 col-md-6"><strong>Teléfono:</strong> {leadSeleccionado.telefono}</div>}
                                        {leadSeleccionado.email     && <div className="col-12 col-md-6"><strong>Email:</strong> {leadSeleccionado.email}</div>}
                                        {leadSeleccionado.campaignId && <div className="col-12"><strong>Campaña:</strong> <span className="text-muted">{leadSeleccionado.campaignId}</span></div>}
                                        <div className="col-12">
                                            <strong>Recibido:</strong>{" "}
                                            <span className="text-muted">
                                                {new Date(leadSeleccionado.fechaRecibido).toLocaleString("es-AR")}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {/* Formulario de carga */}
                                <div className="mb-3">
                                    <label className="form-label fw-bold" style={{ fontSize: "0.85rem" }}>
                                        Estado del lead
                                    </label>
                                    <select
                                        className="form-select form-select-sm"
                                        value={form.estado}
                                        onChange={e => setForm(f => ({ ...f, estado: e.target.value }))}
                                    >
                                        {ESTADOS.map(e => (
                                            <option key={e.value} value={e.value}>{e.label}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label fw-bold" style={{ fontSize: "0.85rem" }}>
                                        Observaciones / Notas
                                    </label>
                                    <textarea
                                        className="form-control form-control-sm"
                                        rows={5}
                                        placeholder="Ingresá notas sobre este lead: motivo de contacto, interés manifestado, próximos pasos..."
                                        value={form.observaciones}
                                        onChange={e => setForm(f => ({ ...f, observaciones: e.target.value }))}
                                    />
                                </div>

                                {mensaje && (
                                    <div className={`alert alert-${mensaje.tipo} py-2 mb-3`}>
                                        <small>{mensaje.texto}</small>
                                    </div>
                                )}

                                <button
                                    className="btn btn-primary btn-sm"
                                    onClick={guardar}
                                    disabled={guardando || !form.estado}
                                >
                                    {guardando
                                        ? <><span className="spinner-border spinner-border-sm me-1" />Guardando...</>
                                        : "Guardar cambios"}
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
